import lapdev from '../../lapdev';


export function createSetupIntent(data) {
    return lapdev.post('payment/createSetupIntent', data);
}

export function createStripeCustomer(data) {
    return lapdev.post('payment/createStripeCustomer', data);
}